import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";

import { InputModule } from "@intocare/ui";

@Component({
	selector: "custom-form-toggle",
	imports: [ReactiveFormsModule, InputModule],
	template: `
		<div class="dynamic-field form-toggle" [formGroup]="group">
			<label>
				<ic-toggle [formControlName]="config.name" />

				<ng-content select="h3" />
			</label>
		</div>
	`,
	styleUrls: ["toggle.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormToggleComponent {
	@Input() config: any;
	@Input() group: UntypedFormGroup;
}
